import * as React from 'react';
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useAppDispatch } from '../../storeHook';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../utils/analytics';
import { Box } from '@mui/material';
import tutorialsIcon from '../../assets/icons/tutorilas icon.svg';
import { useNavigate } from 'react-router-dom';
import { GLOBAL_CONSTANTS } from '../../utils/appConstant';
import { updateAppTheme } from '../../reduxActions/theme';
import RateReviewIcon from '@mui/icons-material/RateReview';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 48,
  height: 24,
  borderRadius: 12,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 3,
    color: 'rgba(182, 241, 78, 1)',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: 'rgba(60, 181, 74, 1)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor:
          theme.palette.mode === 'dark' ? '#fff' : '#fff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 18,
    height: 18,
    borderRadius: 9,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(239, 239, 239, 1)'
        : 'rgba(239, 239, 239, 1)',
    boxSizing: 'border-box',
  },
}));

type TTheme = 'light' | 'dark';

const DEFAULT_THEME: TTheme = 'dark';
const getTheme = () => {
  switch (localStorage.getItem('appTheme')) {
    case 'dark':
      return 'dark';

    case 'light':
      return 'light';
    default:
      return DEFAULT_THEME;
  }
};

export default function AppTheme() {
  const [theme, setTheme] = React.useState<TTheme>(
    getTheme()
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const updateTheme = () => {
    localStorage.setItem('appTheme', theme);
    document.body.setAttribute('theme', theme);
  };

  const toggleTheme = () => {
    const changeThemeTo =
      theme === 'light' ? 'dark' : 'light';
    setTheme(changeThemeTo);
    dispatch(updateAppTheme({theme:changeThemeTo}))
    appLogEvent(CUSTOM_EVENTS.THEME_CHANGED, {
      theme: changeThemeTo,
    });
  };

  React.useEffect(() => {
    updateTheme();
  }, [theme]);
  const textColor =
    theme === 'dark'
      ? 'rgba(228, 215, 215, 1)'
      : 'rgba(128, 128, 128, 1)';
  return (
    <FormGroup>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center">
        <Box display="flex" alignItems="center" gap={0.5}>
          <a
            href="https://forms.office.com/r/aQP6Mbdjjb"
            target="_blank"
            rel="noopener noreferrer">
            <RateReviewIcon
              className="tutorial-icon"
              sx={{ color: 'rgba(60, 181, 74, 1)' }}
            />
            <button className="tutorial-button">
              {GLOBAL_CONSTANTS.FEEDBACK}
            </button>
          </a>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          gap={0.5}
          onClick={() => {
            navigate('/tutorial');
          }}>
          <img
            src={tutorialsIcon}
            alt="Tutorials"
            className="tutorial-icon"
          />
          <button className="tutorial-button">
            {GLOBAL_CONSTANTS.TUTORIALS}
          </button>
        </Box>
        <Typography
          fontSize={'15px'}
          sx={{ color: textColor }}>
          Light
        </Typography>
        <AntSwitch
          defaultChecked={theme === 'dark'}
          onClick={toggleTheme}
        />
        <Typography
          fontSize={'15px'}
          sx={{ color: textColor }}>
          Dark
        </Typography>
      </Stack>
    </FormGroup>
  );
}
